module.exports = __webpack_public_path__ + "img/vi_vn2.e1f64139.png";